import React from 'react';
import {
  CoderListItem,
  CoderListItemProps
} from '../coder-list-item/coder-list-item';
import './coder-list-section.scss';

export interface CoderListSectionProps {
  title: string;
  coders: CoderListItemProps[];
}

export const CoderListSection: React.FC<CoderListSectionProps> = ({
  title,
  coders
}) => {
  return (
    <div className="cmx-coder-list-section">
      <h4 className="cmx-coder-list-section__heading">
        {title} ({coders.length} coders)
      </h4>
      <div className="cmx-coder-list-section__list">
        {coders.map((coder, index) => (
          <CoderListItem key={`${coder.coderName}-${index}`} {...coder} />
        ))}
      </div>
    </div>
  );
};

CoderListSection.displayName = 'CoderListSection';
